// extracted by mini-css-extract-plugin
module.exports = {"styledButton":"VcHTe2rd"};